// extracted by mini-css-extract-plugin
export default {"relateTitle":"index_relateTitle_aD97G","titleText":"index_titleText_6kwHp","moreText":"index_moreText_85jPI","moreIcon":"index_moreIcon_W3AN9"};